import { create } from "zustand";

const useOrderItemsLoadStore = create((set) => ({
  orderItemsLoad: [],

  removeOrderLoadItem: (index) =>
    set((state) => ({
      orderItemsLoad: state.orderItemsLoad.filter(
        (_, itemIndex) => itemIndex !== index
      ),
    })),

  addOrderItemLoad: (item) =>
    set((state) => ({
      orderItemsLoad: [...state.orderItemsLoad, item],
    })),

  clearOrderItemsLoad: () =>
    set({
      orderItemsLoad: [],
    }),

  updateOrderItemLoad: (index, orderItemLoad) =>
    set((state) => ({
      orderItemsLoad: state.orderItemsLoad.map((orderItemL, i) => {
        if (i === index) return orderItemLoad;
        return orderItemL;
      }),
    })),
}));

export default useOrderItemsLoadStore;
